/**
 * Cost breakdown block — used by both the trialing/expired subscribe card
 * and the active-subscriber modify-addons collapsible.
 */
export default function PriceEstimate({ estimate, isProvider, extraOrgs, extraCompanies, extraAdmins, extraUsers }) {
  if (!estimate) return null;
  return (
    <div className="bg-gray-50 rounded-lg p-4 space-y-2" data-testid="price-estimate">
      <div className="flex justify-between text-sm text-gray-600">
        <span>Base</span><span>${estimate.base.toFixed(2)}</span>
      </div>
      {isProvider && estimate.extra_orgs_cost > 0 && (
        <div className="flex justify-between text-sm text-gray-600">
          <span>Extra Organizations ({extraOrgs})</span><span>${estimate.extra_orgs_cost.toFixed(2)}</span>
        </div>
      )}
      {estimate.extra_companies_cost > 0 && (
        <div className="flex justify-between text-sm text-gray-600">
          <span>Extra Companies ({extraCompanies})</span><span>${estimate.extra_companies_cost.toFixed(2)}</span>
        </div>
      )}
      {estimate.extra_admins_cost > 0 && (
        <div className="flex justify-between text-sm text-gray-600">
          <span>Extra Admins ({extraAdmins})</span><span>${estimate.extra_admins_cost.toFixed(2)}</span>
        </div>
      )}
      {estimate.extra_users_cost > 0 && (
        <div className="flex justify-between text-sm text-gray-600">
          <span>Extra Users ({extraUsers})</span><span>${estimate.extra_users_cost.toFixed(2)}</span>
        </div>
      )}
      <div className="flex justify-between text-base font-semibold text-gray-900 pt-2 border-t border-gray-200">
        <span>Monthly Total</span><span className="text-teal-600">${estimate.total_monthly.toFixed(2)}/mo</span>
      </div>
    </div>
  );
}
